/**
 * SystemRevenueService
 * Service for managing system revenue tracking
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for system revenue CRUD operations with order/vendor queries and summaries
 */
export class SystemRevenueService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SystemRevenueService.DEFAULT_SERVICE_PATH,
            basePath: SystemRevenueService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all revenue records for a specific order
     * @param orderId - The order ID
     * @returns Array of system revenue records
     */
    async getByOrder(orderId) {
        const response = await this.getByOrderRaw(orderId);
        return response.data ?? [];
    }
    /**
     * Get all revenue records for a specific order with full response
     * @param orderId - The order ID
     * @returns ResponseData with array of system revenue records
     */
    getByOrderRaw(orderId) {
        const url = this.buildUrl(`order/${orderId}`);
        return this.http.get(url);
    }
    /**
     * Get all revenue records for a specific vendor
     * @param vendorId - The vendor ID
     * @returns Array of system revenue records
     */
    async getByVendor(vendorId) {
        const response = await this.getByVendorRaw(vendorId);
        return response.data ?? [];
    }
    /**
     * Get all revenue records for a specific vendor with full response
     * @param vendorId - The vendor ID
     * @returns ResponseData with array of system revenue records
     */
    getByVendorRaw(vendorId) {
        const url = this.buildUrl(`vendor/${vendorId}`);
        return this.http.get(url);
    }
    /**
     * Get aggregated revenue summary for a date range
     * @param from - Start date string
     * @param to - End date string
     * @returns The revenue summary
     */
    async getSummary(from, to) {
        const response = await this.getSummaryRaw(from, to);
        if (!response.data) {
            throw new Error(`Failed to get revenue summary for period: ${from} to ${to}`);
        }
        return response.data;
    }
    /**
     * Get aggregated revenue summary for a date range with full response
     * @param from - Start date string
     * @param to - End date string
     * @returns ResponseData with the revenue summary
     */
    getSummaryRaw(from, to) {
        const url = this.buildUrl(`summary?from=${from}&to=${to}`);
        return this.http.get(url);
    }
}
SystemRevenueService.DEFAULT_SERVICE_PATH = 'system';
SystemRevenueService.BASE_PATH = 'api/system-revenue';
//# sourceMappingURL=SystemRevenueService.js.map